import { atomWithReset as stateSegmentWithReset } from 'jotai/utils';

/**
 * State segment for storing agentic planner (CHAT_CONVERSATION) session info.
 * This is populated when getSessionDetails is called at app startup.
 */
export type AgenticSessionState = {
  /** The CHAT_CONVERSATION session ID, if one exists */
  chatSessionId: string | null;
  /** Whether the session check has been completed */
  hasChecked: boolean;
};

export const agenticSessionSegment = stateSegmentWithReset<AgenticSessionState>(
  {
    chatSessionId: null,
    hasChecked: false,
  }
);

agenticSessionSegment.debugLabel = 'agenticSessionSegment';
